import { render, staticRenderFns } from "./TrackPurchase.vue?vue&type=template&id=f3af954a&scoped=true&"
import script from "./TrackPurchase.vue?vue&type=script&lang=js&"
export * from "./TrackPurchase.vue?vue&type=script&lang=js&"
import style0 from "./TrackPurchase.vue?vue&type=style&index=0&id=f3af954a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3af954a",
  null
  
)

export default component.exports